import React from "react";
import { connect } from 'react-redux';
import { useNavigate, useLocation } from "react-router-dom";

import { buyersGuideSidebarRoutes as routesBuyersGuide } from "../../routes/index";
import styles from '../../styles/shared/Sidebar.module.css'
import { IoArrowBackOutline } from "react-icons/io5";

const Sidebar = ({ 
  isMobile,
  open,
  onClose, 
  buyersGuide: { specificBuyersGuideData }, 
}) => {
  const navigate = useNavigate();
  const { pathname } = useLocation()

 const handleLink = (path, disabled) => {
    if (disabled) {
        return
    }

    navigate(path)
  }
  
  return Object.keys(specificBuyersGuideData).length > 0 && (
    (!isMobile || open) ? (
      <div className={isMobile ? styles.sidebar_buyers_guide_wrapper : ''} onClick={() => isMobile ? onClose() : {}}>
        <div className={styles.sidebar_main_container}>
          <div className={styles.sidebar_single_link} onClick={() => handleLink(`/buyers-guide`)}>
            <IoArrowBackOutline size={25} />
            <p className={styles.single_link_title}>Back to CMS</p>
          </div>
                
          <div className={styles.sidebar_links_container}>
            {
              routesBuyersGuide.map((route, idx) => {
                const disabled = disableCaseCheck(idx, specificBuyersGuideData.curr_stage)
                return (
                  <div
                      key={`route-${idx}`} 
                      className={`${styles.sidebar_single_link} ${pathname.startsWith(route.path) ? styles.sidebar_selected : ''} ${disabled ? styles.sidebar_link_disabled : ''}`}
                      onClick={() => handleLink(route.path, disabled)}
                  >
                    <p className={styles.single_link_title}>{route.id}</p>
                  </div>
                )
              })
            }
          </div>
    
        </div>
      </div>)
    : null
  );
};

const mapStateToProps = state => ({
  buyersGuide: state.buyersGuide
});

export default connect(
  mapStateToProps
)(Sidebar);

const disableCaseCheck = (index, curr_stage) => {
  let disabled = false

  if (curr_stage < 5) {
    if (index >= curr_stage) {
      disabled = true
    }
  }
  else if (curr_stage >= 5) {
    const disabledAt5 = [0, 1, 3]

    if (disabledAt5.indexOf(index) !== -1) {
      disabled = true
    }

  }

  return disabled
}